// extracted by mini-css-extract-plugin
module.exports = {"resultColor":"#29abe0"};